import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  sidebarDrawer: {
    transition: "width ".concat(palette.transitions.short),
    '& .MuiDrawer-paper': {
      position: 'static',
      left: 'initial',
      top: 'initial',
      background: palette.shades[200],
      boxShadow: 'none',
      borderRight: "1px solid ".concat(palette.shades[300])
    }
  },
  sidebar: {
    visibility: 'visible',
    flexShrink: '0',
    '& .MuiTab-root': {
      minWidth: 'initial',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      whiteSpace: 'nowrap'
    }
  },
  isOpen: {
    width: '200px'
  },
  isClosed: {
    width: '56px'
  },
  tab: {
    padding: '0',
    '& .MuiTab-iconWrapper': {
      padding: '15px 18px',
      marginBottom: '0px'
    }
  },
  subTab: {
    padding: '6px 18px 6px 60px'
  },
  hidden: {
    height: '0',
    padding: '0'
  },
  visible: {
    height: '32px'
  },
  nbmContent: {
    padding: '16px',
    transition: "padding ".concat(palette.transitions.short),
    '&.isClosed': {
      padding: '16px 8px',
      '& .MuiButton-root': {
        padding: '8px',
        '& .actionText': {
          width: '0',
          margin: '0'
        }
      }
    }
  },
  nbmContentActions: {
    marginBottom: '32px',
    '& .MuiButton-root': {
      width: '100%',
      minWidth: '0',
      padding: '6px !important',
      '& .MuiSvgIcon-root path': {
        fill: palette.shades[100]
      },
      '& .actionText': {
        marginLeft: '4px',
        overflow: 'hidden',
        transition: "width ".concat(palette.transitions.short)
      }
    }
  },
  nbmContentItem: {
    '&:not(:last-child)': {
      marginBottom: '8px'
    },
    '& .MuiButton-root': {
      width: '100%',
      minWidth: '0px',
      color: palette.shades[700],
      fontSize: '15px',
      padding: '8px 16px 8px 8px',
      justifyContent: 'flex-start',
      transition: "padding ".concat(palette.transitions.short),
      '&.Mui-disabled': {
        opacity: '0.5',
        backgroundColor: 'transparent'
      }
    },
    '& .MuiSvgIcon-root': {
      '& path': {
        fill: palette.shades[600]
      }
    },
    '& .actionText': {
      marginLeft: '8px',
      overflow: 'hidden',
      transition: "width ".concat(palette.transitions.short)
    },
    // The shortcut rides inside actionText so the collapsed rail clips it with the label.
    '& kbd': {
      marginLeft: '8px',
      padding: '1px 5px',
      borderRadius: '4px',
      border: "1px solid ".concat(palette.shades[400]),
      color: palette.shades[600],
      fontFamily: 'inherit',
      fontSize: '11px',
      verticalAlign: 'middle'
    },
    '&.active': {
      '& .MuiButton-root': {
        color: palette.common.black,
        backgroundColor: palette.shades[300]
      },
      '& .MuiSvgIcon-root path': {
        fill: '#212934'
      }
    }
  }
});
export default useStyles;